import {AbstractVisualFeature} from '../../visual-feature.js';
import {MatchAcca} from '../match-acca.js';

import {matchAccaSlipFactory} from './match-acca-slip.factory';

import PALETTE_SCHEMA from './match-acca-slip.palette-schema.yaml';

class MatchAccaSlipFeature extends AbstractVisualFeature {
    get name() {
        return 'MatchAccaSlip';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return matchAccaSlipFactory(PALETTE);
    }
}

new MatchAccaSlipFeature(MatchAcca);
